const homeContent = require("static/content/de/home.json");
const productsContent = require("static/content/de/products.json");
const resultsContent = require("static/content/de/results.json");

export default {
  home: homeContent,
  products: productsContent,
  results: resultsContent,
};
